import './job-queue.scss';

import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

// Manager Job Queue Page
import JobQueueHeader from './components/JobQueueHeader';
import JobQueueTable from './components/JobQueueTable';

const JobQueue: React.FC = () => {
  return (
    <Box className="job-queue-view inter-font-family">
      <JobQueueHeader />

      <Box className="job-queue-content">
        <Box className="table-section">
          <JobQueueTable />
        </Box>
      </Box>
    </Box>
  );
};

export default observer(JobQueue);
